export default __webpack_public_path__ + "static/media/ogilvy-logo.c7c79368.svg";